// A PARTNER'S HOME IS THEIR PROJECT (owner, 2026-10-12: a BES supervisor
// signing in landed on the estimation dashboard of BES's own, empty company).
// One project opens straight in; several open the project list.
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { url, tokenRef } from "api";

export function partnerHome(projects) {
  const list = Array.isArray(projects) ? projects : (projects && projects.projects) || [];
  if (list.length === 1 && list[0] && list[0]._id) return `/coordination/${list[0]._id}`;
  return "/coordination";
}

export default function PartnerLanding() {
  const history = useHistory();
  useEffect(() => {
    let alive = true;
    fetch(`${url}/projects/picker`, { headers: { Authorization: `Bearer ${localStorage.getItem(tokenRef)}` } })
      .then((r) => (r.ok ? r.json() : []))
      .catch(() => [])
      .then((rows) => { if (alive) history.replace(partnerHome(rows)); });
    return () => { alive = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div style={{ minHeight: "calc(50 * var(--vh))", display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontFamily: "Arial, sans-serif" }}>
      Opening your project...
    </div>
  );
}
